import _Promise from 'babel-runtime/core-js/promise';
import _typeof from 'babel-runtime/helpers/typeof';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _Object$keys from 'babel-runtime/core-js/object/keys';
/**
 * @description packages useful request properties into an object
 * @param {XMLHttpRequest} xhr the underlying request object
 * @returns {{}}
 */
var craftResponse = function craftResponse(xhr) {
    var response = {
        status: 0,
        statusText: '',
        response: {},
        responseText: '',
        responseUrl: '',
        DONE: 0,
        OPENED: 0
    };

    _Object$keys(response).forEach(function (key) {
        return response[key] = xhr[key];
    });

    return response;
};

/**
 * @property {{}} options
 * @property {XHMLHttpRequest} xhr
 * @property {Promise} promise
 * @property {{}} response
 */

var XHRPromise = function () {
    /**
     * @description Initializes a new request 
     * @param {string} method
     * @param {string} url
     */
    function XHRPromise(method, url) {
        _classCallCheck(this, XHRPromise);

        if (typeof method !== 'string' || typeof url !== 'string') throw new Error('Invalid args exception');
        this.options = {};
        this.options.method = method;
        this.options.url = url;
        this.xhr = null;
        this.response = {};
    }

    /**
     * @description adds new parameters to the current request 
     * @param {{}} params key value pair object
     */


    _createClass(XHRPromise, [{
        key: 'addParams',
        value: function addParams(params) {
            if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) !== 'object') throw new Error('Invalid args exception');
            this.options.params = params;
            if (this.options.method === 'GET') {
                var encoded = this.encodeURIObject(params);
                this.options.url = this.options.url.concat('?', encoded);
            }
        }

        /**
         * @description adds new headers to the current request 
         * @param {{}} headers key value pair object
         */

    }, {
        key: 'addHeaders',
        value: function addHeaders(headers) {
            var _this = this;

            if ((typeof headers === 'undefined' ? 'undefined' : _typeof(headers)) !== 'object') throw new Error('Invalid args exception');
            if (typeof this.options.headers === 'undefined') this.options.headers = {};
            _Object$keys(headers).forEach(function (key) {
                return _this.options.headers[key] = headers[key];
            });
        }
    }, {
        key: 'addPayload',
        value: function addPayload(payload, contentType) {
            this.options.payload = payload;
            this.addHeaders({
                'Content-type': contentType
            });
        }

        /**
         * @description Format the response
         * @param {string} type Format type. Supported values: JSON, String. Default: String
         */

    }, {
        key: 'setResponseType',
        value: function setResponseType() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "String";

            this.responseType = type;
        }

        /**
         * @description stringify, join, and encode key vlue pairs 
         * @param {{}} params key value pair object
         * @returns {string}
         */

    }, {
        key: 'encodeURIObject',
        value: function encodeURIObject(params) {
            if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) !== 'object') throw new Error('Invalid args exception');
            return _Object$keys(params).map(function (key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
            }).join('&');
        }

        /**
         * @summary Use the provided options to craft and send a request, this instances 
         * underlying xhr and promise will be created. When the xhr request resolves the
         * this instances request object will be filled.
         */

    }, {
        key: 'createAndSend',
        value: function createAndSend() {
            var _this2 = this;

            var xhr = new XMLHttpRequest();

            // Credentials
            if (this.options.username && this.options.password) {
                xhr.open(this.options.method, this.options.url, true, this.options.username, this.options.password);
            } else {
                xhr.open(this.options.method, this.options.url);
            }

            // headers in config
            if (this.options.headers) {
                _Object$keys(this.options.headers).forEach(function (key) {
                    return xhr.setRequestHeader(key, _this2.options.headers[key]);
                });
            }

            var self = this;

            return new _Promise(function (resolve, reject) {
                xhr.onload = function () {
                    var response = craftResponse(xhr);

                    if (this.status >= 200 && this.status < 300) {
                        if (self.responseType === 'JSON') {
                            var data = void 0;

                            try {
                                data = JSON.parse(response.responseText);
                            } catch (e) {
                                this.dlog.error('Request failed: ' + url);
                                this.dlog.error(e);
                                reject("Unable to parse the Json response");
                                return;
                            }

                            resolve(data);
                        } else if (self.responseType === 'String') {
                            resolve(response.responseText);
                        } else {
                            resolve(response);
                        }
                    } else {
                        reject(response);
                    }
                };

                xhr.onerror = function () {
                    reject(craftResponse(xhr));
                };

                // Params will be ignored in get request
                // in constructor url modified with params on GET 
                if (_this2.options.payload) {
                    xhr.send(_this2.options.payload);
                } else {
                    xhr.send(_this2.options.params);
                }
            });
        }
    }]);

    return XHRPromise;
}();

export default XHRPromise;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/XHRPromise.js
// module id = 504
// module chunks = 0